import React, { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Images } from "lucide-react";

export default function ImageLibrary() {
  const [imgs, setImgs] = useState([]);
  const [procImgs, setProcImgs] = useState([]);
  useEffect(() => {
    api.get("/images").then((r) => setImgs(r.data));
    api.get("/procedures").then((r) => {
      const all = [];
      r.data.forEach((p) => [p.cover_image, ...(p.gallery || [])].filter(Boolean).forEach((u) => all.push({ url: u, name: p.name })));
      setProcImgs(all);
    });
  }, []);

  const uploaded = imgs.map((f) => ({ url: f.url, name: f.original_filename }));
  const combined = [...uploaded, ...procImgs].filter((v, i, a) => a.findIndex((x) => x.url === v.url) === i);

  return (
    <div className="space-y-6" data-testid="images-page">
      <div><h2 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Image Library</h2><p className="text-slate-500 mt-1">{combined.length} images across procedures</p></div>
      {combined.length === 0 ? (
        <Card className="p-12 rounded-xl border-slate-200 shadow-sm flex flex-col items-center text-slate-400"><Images className="h-8 w-8 mb-2" /> No images yet. Upload images from a procedure's detail page.</Card>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {combined.map((im, i) => (
            <Card key={i} className="rounded-xl overflow-hidden border-slate-200 dark:border-slate-800 shadow-sm group">
              <img src={imgUrl(im.url)} alt={im.name} className="w-full aspect-square object-cover bg-slate-100 group-hover:scale-105 transition-transform duration-300" />
              <div className="p-2 text-xs text-slate-500 truncate">{im.name}</div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
